import M$plugin$Simplebaselayerselector from '/home/epardo/proyectos/simplebaselayerselector/src/facade/js/simplebaselayerselector';
import M$control$SimplebaselayerselectorControl from '/home/epardo/proyectos/simplebaselayerselector/src/facade/js/simplebaselayerselectorcontrol';
import M$impl$control$SimplebaselayerselectorControl from '/home/epardo/proyectos/simplebaselayerselector/src/impl/ol/js/simplebaselayerselectorcontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.Simplebaselayerselector = M$plugin$Simplebaselayerselector;
window.M.control.SimplebaselayerselectorControl = M$control$SimplebaselayerselectorControl;
window.M.impl.control.SimplebaselayerselectorControl = M$impl$control$SimplebaselayerselectorControl;
